import { To } from "react-router-dom-v5-compat";

import { Link, Stack, Text, TextButton } from "@seneca/senekit";

type LinkProps =
  | {
      bottomLink: To;
      onBottomLinkClick?: undefined;
    }
  | {
      bottomLink?: undefined;
      onBottomLinkClick: () => void;
    };

type SignUpFormBottomLinkProps = {
  bottomLinkText: string;
  bottomText?: string;
} & LinkProps;

export default function SignUpFormBottomLink({
  bottomLinkText,
  bottomText,
  bottomLink,
  onBottomLinkClick
}: SignUpFormBottomLinkProps) {
  return (
    <Stack space="small" align="center">
      {bottomText && (
        <Text tone="neutral" size="small" emphasis="medium">
          {bottomText}
        </Text>
      )}
      {onBottomLinkClick ? (
        <TextButton onClick={onBottomLinkClick} size="small">
          {bottomLinkText}
        </TextButton>
      ) : (
        <Link to={bottomLink} size="small">
          {bottomLinkText}
        </Link>
      )}
    </Stack>
  );
}
